<template>
  <v-card outlined height="100%">
    <v-card-actions class="py-0">
      <v-toolbar dense flat>
        <v-menu close-on-click offset-y v-for="(rollen, key, rolleIndex) in rollenGruppe" :key="rolleIndex">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">{{ key }}<v-icon>keyboard_arrow_down</v-icon></v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(rolle, rolleIndex) in rollen" :key="rolleIndex" @click="selectedSeite = rolle">
              <v-list-item-title>{{ rolle.titel }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn class="ml-2" @click="addRolle()" outlined>Neue Rolle</v-btn>
        <v-btn class="ml-2" outlined @click="deleteRolle"><v-icon>delete</v-icon>Seite löschen</v-btn>
        <v-btn class="ml-2 primary" @click="saveRollen()">Speichern</v-btn>
      </v-toolbar>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-row class="pa-0">
        <v-col cols="6">
          <v-card outlined class="mb-2">
            <v-card-title> Allgemein </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-text-field dense hide-details outlined label="Bezeichnung" v-model="selectedSeite.titel">
                    <template v-slot:append-outer>
                      <v-tooltip bottom max-width="200px">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">help</v-icon>
                        </template>
                        Die Bezeichnung der Rolle. Diese wird in der Navigation angezeigt.
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    hide-details
                    :items="['Chargen', 'AHV', 'HBV', 'Ämter', 'Kommissionen', 'Zirkel']"
                    label="Gruppe"
                    v-model="selectedSeite.gruppe"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip bottom max-width="200px">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">help</v-icon>
                        </template>
                        Rollen können gruppiert werden. In der Rollenübersicht oder den Widgets können dann die
                        Rollenverteilung nach Gruppe angezeigt werden.
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="selectedSeite.berechtigt"
                    :items="bundesbruderselect"
                    outlined
                    chips
                    deletable-chips
                    label="Berechtigt"
                    multiple
                    dense
                    hide-details
                  >
                    <template v-slot:append-outer>
                      <v-tooltip bottom max-width="200px">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">help</v-icon>
                        </template>
                        Die eingetragenen Personen können auf das Modul zugreifen.
                      </v-tooltip>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeBerechtigung(data.item.value)"
                        class="mt-1"
                      >
                        {{ data.item.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.text"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-avatar :size="32" color="transparent" class="mr-4">
                    <img :src="'/static/menu-icon/' + selectedSeite.bild + '.png'" />
                  </v-avatar>
                  <v-select
                    dense
                    outlined
                    hide-details
                    :items="[
                      'wappen',
                      'AHV',
                      'HBV',
                      'Senior',
                      'Consenior',
                      'Fuxmajor',
                      'Schriftfuhrer',
                      'Kassierer',
                      'Bierwart',
                    ]"
                    label="Bild"
                    v-model="selectedSeite.bild"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip bottom max-width="200px">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">help</v-icon>
                        </template>
                        Das Bild erscheint in der Navigation.
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card outlined>
            <v-card-title> Mail Einstellungen </v-card-title>
            <v-row class="mb-1">
              <v-col cols="12">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  label="Absendername"
                  placeholder="Verein Position"
                  v-model="selectedSeite.sendMail.absender"
                >
                  <template v-slot:append-outer>
                    <v-tooltip bottom max-width="200px">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">help</v-icon>
                      </template>
                      Der Absendername wird in Mailprogrammen angezeigt
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  label="Mailadresse"
                  v-model="selectedSeite.sendMail.adresse"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                An welche Mailadresse sollen Antworten gesendet werden?
                <v-radio-group v-model="selectedSeite.sendMail.replyTo">
                  <v-radio
                    label="Absender (Die private Adresse der Person, die die Mail abgeschickt hat.)"
                    value="absender"
                  ></v-radio>
                  <v-radio label="From (Die Amtsmailadresse, welche oben eingetragen wurde)" value="from"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card outlined>
            <v-card-title>
              Module
              <v-spacer></v-spacer>
              <v-tooltip bottom max-width="200px">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help</v-icon>
                </template>
                Die Module entsprechen den einzelnen Unterseiten und können individuell belegt und angepasst werden.
              </v-tooltip>
            </v-card-title>
            <v-row no-gutters>
              <v-col cols="12">
                <v-expansion-panels>
                  <draggable class="v-item-group theme--light v-expansion-panels" v-model="selectedSeite.module">
                    <v-expansion-panel v-for="modul in selectedSeite.module" :key="modul.id">
                      <v-expansion-panel-header class="ma-0 pa-0">
                        <v-list class="elevation-0 pa-0">
                          <v-list-item>
                            <v-list-item-avatar>
                              <v-icon>{{ modul.icon }}</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title v-html="modul.name"></v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-icon @click="removeModul(modul)">close</v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="pa-0">
                        <v-text-field
                          label="Titel"
                          v-model="modul.name"
                          hint="Dieser Titel wird in der Menüleiste angezeigt."
                        ></v-text-field>
                        <div v-for="prop in modul.props" :key="prop">
                          <v-select
                            :items="kassen"
                            :label="prop.name"
                            v-model="prop.wert"
                            :hint="prop.hint"
                            v-if="prop.name === 'Kasse'"
                          ></v-select>
                          <v-select
                            :items="kalender"
                            :label="prop.name"
                            v-model="prop.wert"
                            :hint="prop.hint"
                            v-if="prop.name === 'Kalender'"
                            multiple
                            chips
                            deletable-chips
                            clearable
                          ></v-select>
                          <v-text-field :label="prop.name" v-model="prop.wert" :hint="prop.hint" v-else></v-text-field>
                        </div>
                        <v-row v-if="modul.id === 1" no-gutters>
                          <v-col cols="12">
                            <v-expansion-panels>
                              <draggable class="v-item-group theme--light v-expansion-panels" v-model="modul.submodule">
                                <v-expansion-panel v-for="modul in modul.submodule" :key="modul.id">
                                  <v-expansion-panel-header class="ma-0 pa-0">
                                    <v-list class="elevation-0 pa-0">
                                      <v-list-item>
                                        <v-list-item-avatar>
                                          <v-icon>unfold_more</v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                          <v-list-item-title v-html="modul.name"></v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                          <v-icon @click="removeSubModul(modul)">close</v-icon>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </v-list>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content class="pa-0">
                                    <v-text-field
                                      label="Titel"
                                      v-model="modul.name"
                                      hint="Dieser Titel wird in der Menüleiste angezeigt."
                                    ></v-text-field>
                                    <div v-for="prop in modul.props" :key="prop">
                                      <v-select
                                        :items="kassen"
                                        :label="prop.name"
                                        v-model="prop.wert"
                                        :hint="prop.hint"
                                        v-if="prop.name === 'Kasse' || prop.name === 'Konto'"
                                      ></v-select>
                                      <v-text-field
                                        :label="prop.name"
                                        v-model="prop.wert"
                                        :hint="prop.hint"
                                        v-else
                                      ></v-text-field>
                                    </div>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </draggable>
                            </v-expansion-panels>
                            <v-btn @click="showSubModule = true" block outlined class="my-2"
                              ><v-icon>add</v-icon></v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </draggable>
                </v-expansion-panels>
                <v-btn @click="showModule = true" block outlined class="my-2"><v-icon>add</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-dialog v-model="showModule" width="80%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
          <v-card class="pa-0 ma-0" height="650px">
            <v-card-title>
              Module
              <v-spacer></v-spacer>
              <v-btn icon @click="showModule = false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-2">
              <v-row class="pa-0">
                <v-col cols="2" v-for="modul in module" :key="modul.id">
                  <v-card
                    @click="addModul(modul)"
                    outlined
                    height="120px"
                    class="subtitle-2 text-center pt-3 primary"
                    dark
                  >
                    <v-avatar>
                      <v-icon>{{ modul.icon }}</v-icon>
                    </v-avatar>
                    <br />
                    {{ modul.name }}
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showSubModule" width="60%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
          <v-card class="pa-0 ma-0" height="650px">
            <v-card-title>
              Submodule
              <v-spacer></v-spacer>
              <v-btn icon @click="showSubModule = false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-2">
              <v-row class="pa-0">
                <v-col cols="3" v-for="modul in subModule" :key="modul.id">
                  <v-card
                    @click="addSubModul(modul)"
                    outlined
                    height="120px"
                    class="subtitle-2 text-center pt-3 primary"
                    dark
                  >
                    <v-avatar>
                      <v-icon>{{ modul.icon }}</v-icon>
                    </v-avatar>
                    <br />
                    {{ modul.name }}
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import draggable from "vuedraggable";
  export default {
    data() {
      return {
        domainSettings: null,
        showModule: false,
        showSubModule: false,
        selectedSeite: {
          titel: "",
          berechtigt: [],
          module: [],
          mobil: false,
          bild: "wappen",
          admin: false,
          checkbox: false,
          sendMail: {},
          gruppe: "",
        },
        module: [
          { id: 1, value: "uebersicht", icon: "dashboard", name: "Übersicht", submodule: [] },
          {
            id: 2,
            value: "veranstaltungen",
            icon: "event",
            name: "Veranstaltungen",
            props: [{ name: "Kalender", wert: "", hint: "Standardkalender zum erstellen neuer Termine." }],
          },
          {
            id: 3,
            value: "rechnungen",
            icon: "receipt_long",
            name: "Rechnungen",
            props: [{ name: "Kasse", wert: "", hint: "Nur Rechnungen aus dieser Kasse werden angezeigt." }],
          },
          { id: 4, value: "todo", icon: "playlist_add_check", name: "ToDo", props: [] },
          { id: 5, value: "kontakte", icon: "group", name: "Kontakte", props: [] },
          { id: 6, value: "bierwart", icon: "person", name: "Bierwart", props: [] },
          { id: 7, value: "mail", icon: "mail", name: "Mail", props: [] },
          { id: 8, value: "dokumente", icon: "auto_awesome", name: "Dokumente", props: [] },
          { id: 9, value: "bierwartBierlieferungen", icon: "local_shipping", name: "BW Bierlieferungen", props: [] },
          { id: 10, value: "bierwartGetranke", icon: "sports_bar", name: "BW Getränke", props: [] },
          {
            id: 11,
            value: "bierwartGetrankeZahlen",
            icon: "format_list_numbered",
            name: "BW Getränkestand",
            props: [],
          },
          { id: 12, value: "bierwartSchankverlust", icon: "trending_up", name: "BW Schankverlust", props: [] },
          { id: 13, value: "bierwartStriche", icon: "list", name: "BW Striche", props: [] },
          { id: 14, value: "bierwartVeranstaltung", icon: "event", name: "BW Veranstaltung", props: [] },
          { id: 15, value: "bierwartVeranstaltungAbrechnen", icon: "event", name: "BW Veranstaltung Neu", props: [] },
          { id: 16, value: "lexikon", icon: "menu_book", name: "Lexikon", props: [] },
          { id: 17, value: "ahnengalerie", icon: "menu_book", name: "Ahnengalerie", props: [] },
          {
            id: 18,
            value: "kassenbuch",
            icon: "menu_book",
            name: "Kassenbuch",
            props: [{ name: "Kasse", wert: "", hint: "Für welche Kasse soll das Kassenbuch angezeigt werden." }],
          },
          {
            id: 19,
            value: "kontobuch",
            icon: "menu_book",
            name: "Kontobuch",
            props: [{ name: "Konto", wert: "", hint: "Für welche Kasse soll das Kontobuch angezeigt werden." }],
          },
          { id: 20, value: "wirtschaftsplan", icon: "menu_book", name: "Wirtschaftsplan", props: [] },
          { id: 21, value: "couleurstrafen", icon: "receipt_long", name: "Couleurstrafen", props: [] },
          { id: 22, value: "dateien", icon: "folder", name: "Dateien", props: [] },
          {
            id: 22,
            value: "zirkel",
            icon: "groups",
            name: "Zirkel",
            props: [{ name: "Zirkel", wert: "", hint: "In welcher Stadt ist der Zirkel." }],
          },
        ],
        subModule: [
          {
            id: 1,
            value: "chargen",
            icon: "person",
            name: "Chargenliste",
            props: [{ name: "Vorstand", wert: "", hint: "Die Mitglieder dieses Vorstands werden angezeigt." }],
          },
          { id: 2, value: "geburtstage", icon: "cake", name: "Geburtstagsliste", props: [] },
          {
            id: 3,
            value: "jubilaum",
            icon: "cake",
            name: "Jubiläumsliste",
            props: [
              { name: "Semester", wert: "", hint: "Welche Jubel-Semester sollen angezeigt werden? zB 50 oder 100" },
            ],
          },
          {
            id: 4,
            value: "kontakteStatus",
            icon: "group",
            name: "Kontaktliste nach Status",
            props: [{ name: "Status", wert: "", hint: "Nur Kontakte mit diesem Status werden angezeigt." }],
          },
          { id: 5, value: "mailsListe", icon: "list", name: "Mailsliste", props: [] },
          {
            id: 6,
            value: "rechnungenEigene",
            icon: "receipt_long",
            name: "Eigene Rechnungen",
            props: [{ name: "Status", wert: "", hint: "Nur Rechnungen mit diesem Status werden angezeigt." }],
          },
          {
            id: 7,
            value: "rechnungenStatus",
            icon: "receipt_long",
            name: "Rechnungen nach Status",
            props: [
              { name: "Kasse", wert: "", hint: "Nur Rechnungen aus dieser Kasse werden angezeigt." },
              { name: "Status", wert: "", hint: "Nur Rechnungen mit diesem Status werden angezeigt." },
            ],
          },
          { id: 8, value: "ripuaren", icon: "group", name: "Ripuaren", props: [] },
          { id: 9, value: "todosEigene", icon: "playlist_add_check", name: "Liste ToDos", props: [] },
          { id: 10, value: "veranstaltungenListe", icon: "event", name: "Kommende Veranstaltungen", props: [] },
          { id: 11, value: "bundesbruderSuche", icon: "search", name: "Suche für Bundesbrüder", props: [] },
          { id: 12, value: "bierranking", icon: "list", name: "Bierranking", props: [] },
          { id: 13, value: "schankverlust", icon: "list", name: "Schankverlust (Steuer)", props: [] },
          { id: 14, value: "rechnungSuche", icon: "list", name: "Rechnung Suche", props: [] },
          { id: 15, value: "keilkandidaten", icon: "group", name: "Keilkandidaten" },
        ],
      };
    },
    computed: {
      rollenGruppe() {
        return this.rollen.seiten.reduce((gruppen, seite) => {
          if (!gruppen[seite.gruppe]) {
            gruppen[seite.gruppe] = [];
          }
          gruppen[seite.gruppe].push(seite);
          return gruppen;
        }, {});
      },
      rollen() {
        if (this.$store.getters["einstellungen/einstellung"]("rollen")) {
          let rollen = this.$store.getters["einstellungen/einstellung"]("rollen");
          rollen.seiten.forEach((item) => {
            if (!item.sendMail) {
              item.sendMail = {};
            }
          });
          console.log(rollen);
          return rollen;
        } else {
          return [];
        }
      },
      // seite () {
      //   let seiten = this.$store.getters['einstellungen/einstellung']('seiten')
      //   if (seiten[this.select]) {
      //     seiten[this.select].sendMail = {}
      //     return seiten[this.select]
      //   } else {
      //     let seite = {
      //       titel: '',
      //       berechtigt: [],
      //       module: [],
      //       mobil: false,
      //       bild: 'wappen',
      //       admin: false,
      //       checkbox: false,
      //       sendMail: {},
      //       gruppe: ''
      //     }
      //     return seite
      //   }
      // },
      kassen() {
        let kassen = [];
        Object.keys(this.$store.getters["einstellungen/einstellung"]("kassen")).forEach((key) => {
          if (key !== "id") {
            kassen.push({
              value: this.$store.getters["einstellungen/einstellung"]("kassen")[key].name,
              text: this.$store.getters["einstellungen/einstellung"]("kassen")[key].name,
            });
          }
        });
        return kassen;
      },
      kalender() {
        let kalender = [];
        this.$store.getters["einstellungen/einstellung"]("alleKalender").forEach((key) => {
          kalender.push({
            value: key.name,
            text: key.name,
          });
        });
        return kalender;
      },
      bundesbruderselect() {
        let items = this.$store.state.bbrbbr.bbrbbr;
        let bbrbbr = [];
        items.forEach((item) => {
          if (item.vulgo) {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")",
            });
          } else {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname,
            });
          }
        });
        return bbrbbr;
      },
    },
    methods: {
      async getDomainSettings() {
        try {
          const res = await this.$firebase.functions().httpsCallable("getDomain")({
            domain_id: "2p0347z5jq7lzdrn",
          });
          this.domainSettings = res.data.body.data;
          return;
        } catch (error) {
          console.log(error);
          return;
        }
      },
      addRolle() {
        let rollen = this.rollen;
        rollen.seiten.push({
          titel: "Neu",
          berechtigt: [],
          module: [],
          mobil: false,
          bild: "wappen",
          admin: false,
          checkbox: false,
          sendMail: {},
          gruppe: "Ämter",
        });
        this.selectedSeite = {
          titel: "Neu",
          berechtigt: [],
          module: [],
          mobil: false,
          bild: "wappen",
          admin: false,
          checkbox: false,
          sendMail: {},
          gruppe: "Ämter",
        };
        this.$store.dispatch("einstellungen/updateEinstellungData", rollen);
      },
      deleteRolle(item) {
        const index = this.rollen.seiten.indexOf(this.selectedSeite);
        if (index >= 0) this.rollen.seiten.splice(index, 1);
        this.$store.dispatch("einstellungen/updateEinstellungData", this.rollen);
        this.selectedSeite = this.rollen.seite[0];
      },
      addModul(item) {
        this.selectedSeite.module.push(item);
        this.showModule = false;
      },
      removeModul(item) {
        const index = this.selectedSeite.module.indexOf(item);
        if (index >= 0) this.selectedSeite.module.splice(index, 1);
      },
      addSubModul(item) {
        this.selectedSeite.module[0].submodule.push({
          ...item,
          index: this.selectedSeite.module[0].submodule.length + 1,
        });
        this.showSubModule = false;
      },
      removeSubModul(item) {
        const index = this.selectedSeite.module[0].submodule.indexOf(item);
        if (index >= 0) this.selectedSeite.module[0].submodule.splice(index, 1);
      },
      removeBerechtigung(item) {
        const index = this.selectedSeite.berechtigt.indexOf(item);
        if (index >= 0) this.selectedSeite.berechtigt.splice(index, 1);
      },
      saveRollen() {
        console.log(this.rollen);
        this.$store.dispatch("einstellungen/updateEinstellungData", this.rollen);
      },
    },
    mounted() {
      this.getDomainSettings();
    },
    components: {
      draggable,
    },
  };
</script>



// WEBPACK FOOTER //
// Rollen.vue?3ce3cf7c